import script from "./service-order-evaluation.vue?vue&type=script&lang=ts&setup=true"
export * from "./service-order-evaluation.vue?vue&type=script&lang=ts&setup=true"

import "./service-order-evaluation.vue?vue&type=style&index=0&id=c2b6b84c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2b6b84c"]])

export default __exports__